// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'dev',
  version: '1.0.0',
  amplify: {
    Auth: {
      identityPoolId: 'ap-northeast-1:de31b510-8104-42dd-99d1-b5b00782f83f',
      region: 'ap-northeast-1',
      userPoolId: 'ap-northeast-1_lqHC3yoMv',
      userPoolWebClientId: '39f7eo0addpmqab9vp82nvs90h',
    },
    API: {
      endpoints: [
        {
          name: 'company',
          endpoint: 'https://ti0xv40ip5.execute-api.ap-northeast-1.amazonaws.com/dev'
        }
      ]
    },
    Storage: {
      myeventAttachment: {
        bucket: 'dev.unionnest.event.attachment',
        region: 'ap-northeast-1',
        level: 'private'
      }
    }
  },
  API_KEY: 'viZQ7YtD0R4Ud8ZlrfsNu5sRvSb8O0Kx4vFg3WQq',
  // AnalyticsTrackingId: 'G-0D69S7E2TH',
};
